import type { ShiftEmployeeSchedulingDetail, ShiftEmployeeSchedulingDirectory, ShiftStreamEvent } from 'shared-models';

export type EmployeeSchedulingEvent = Extract<ShiftStreamEvent, { type: 'employeePriority.upserted' | 'employeeEligibility.upserted' | 'employeeTipSettings.upserted' | 'employeeLimits.upserted' | 'employeeMetadata.upserted' }>;

export const EMPLOYEE_METADATA_FIELDS = [
  {key:'clockReference',label:'מזהה שעון',maximum:80},
  {key:'payrollReference',label:'מספר עובד לשכר',maximum:80},
  {key:'notes',label:'הערות',maximum:2000},
] as const;

export function applySchedulingDirectoryEvent(snapshot: ShiftEmployeeSchedulingDirectory, event: EmployeeSchedulingEvent): ShiftEmployeeSchedulingDirectory {
  if (event.type === 'employeeLimits.upserted') return { ...snapshot, employees:snapshot.employees.map(employee =>
    employee.employeePk === event.setting.employeePk && (employee.limits?.revision ?? 0) < event.setting.revision
      ? { ...employee, limits:event.setting } : employee) };
  if (event.type === 'employeeTipSettings.upserted') return { ...snapshot, employees: snapshot.employees.map(employee =>
    employee.employeePk === event.setting.employeePk && (employee.tipSettings?.revision ?? 0) < event.setting.revision
      ? { ...employee, tipSettings: event.setting } : employee) };
  if (event.type !== 'employeePriority.upserted') return snapshot;
  const setting = event.setting;
  return { ...snapshot, employees: snapshot.employees.map(employee => employee.employeePk === setting.employeePk && employee.priorityRevision < setting.revision
    ? { ...employee, priority: setting.priority, priorityRevision: setting.revision } : employee) };
}

export function applyEmployeeSchedulingEvent(snapshot: ShiftEmployeeSchedulingDetail, event: EmployeeSchedulingEvent): ShiftEmployeeSchedulingDetail {
  if (snapshot.employee.employeePk !== event.setting.employeePk) return snapshot;
  if (event.type === 'employeeMetadata.upserted') return (snapshot.metadata?.revision ?? 0) < event.setting.revision
    ? {...snapshot,metadata:event.setting} : snapshot;
  if (event.type === 'employeeLimits.upserted') return (snapshot.employee.limits?.revision ?? 0) < event.setting.revision
    ? { ...snapshot, employee:{ ...snapshot.employee,limits:event.setting },
      ...(snapshot.weeklyLimits ? { weeklyLimits:{ ...snapshot.weeklyLimits,limits:event.setting } } : {}) } : snapshot;
  if (event.type === 'employeeTipSettings.upserted') return (snapshot.employee.tipSettings?.revision ?? 0) < event.setting.revision
    ? { ...snapshot, employee: { ...snapshot.employee, tipSettings: event.setting } } : snapshot;
  if (event.type === 'employeePriority.upserted') {
    const setting = event.setting;
    return snapshot.employee.priorityRevision < setting.revision
      ? { ...snapshot, employee: { ...snapshot.employee, priority: setting.priority, priorityRevision: setting.revision } } : snapshot;
  }
  const setting = event.setting;
  return { ...snapshot, roles: snapshot.roles.map(role => role.roleId === setting.roleId && role.revision < setting.revision
    ? { ...role, isEligible: setting.isEligible, revision: setting.revision } : role) };
}